import type { DynamicClient } from '../../../../../client/types/DynamicClient';
import { getLastKnownNetworkRegistry } from '../../../networks/lastKnownNetworkRegistry/getLastKnownNetworkRegistry/getLastKnownNetworkRegistry';
import type { WalletProvider } from '../../walletProvider.types';

type GetActiveNetworkIdFromLastKnownRegistry = (args: {
  client: DynamicClient;
  walletProviderKey: string;
}) => ReturnType<WalletProvider['getActiveNetworkId']>;

export const getActiveNetworkIdFromLastKnownRegistry: GetActiveNetworkIdFromLastKnownRegistry =
  async ({ client, walletProviderKey }) => {
    const networkRegistry = getLastKnownNetworkRegistry(client);

    return networkRegistry.getNetworkId({ walletProviderKey });
  };
